import { tryCatch } from '@whistler-ui/k2/helpers';

import type { WearablesSection } from '../types/faq';

const FAQ_PATH = '/faq.json';

export const getFaq = async (): Promise<WearablesSection[]> => {
  const { data, error } = await tryCatch<WearablesSection[]>(async () => {
    const response = await fetch(FAQ_PATH);

    // faq.json is a static public asset copied into every brand's dist, not an
    // API call. If it is ever missing or misrouted the server answers with the
    // SPA fallback HTML, so checking response.ok is what turns that into a
    // readable error — res.json() alone would fail with "Unexpected token <".
    if (!response.ok) {
      throw new Error(
        `Failed to load ${FAQ_PATH} (${response.status} ${response.statusText})`,
      );
    }

    return (await response.json()) as WearablesSection[];
  });

  if (error) {
    throw error;
  }

  return data ?? [];
};
